import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useGetSavedPostsQuery } from "@/store/api/postApi";
import { IPost } from "@/store/api/postApiData";
import { styles } from "./stylesSavedPost";
import Post from "../Home/components/Post";
import CustomLoader from "@/components/UI/CustomLoader/CustomLoader";

const SavedPost = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const typeParam = searchParams.get("type") || "Post";
  const activeTab = typeParam === "Post" ? "Saved Post" : "Purchased posts";

  const apiType = activeTab === "Saved Post" ? "FREE" : "PAID";

  const {
    data: posts,
    isLoading,
    isFetching,
  } = useGetSavedPostsQuery({ type: apiType }, { refetchOnMountOrArgChange: true });

  const [localPosts, setLocalPosts] = useState<IPost[]>([]);

  useEffect(() => {
    if (posts) {
      setLocalPosts(posts);
    }
  }, [posts]);

  const handleDeletePost = (uid: string) => {
    setLocalPosts((prev) => prev.filter((post) => post.uid !== uid));
  };

  return (
    <Box sx={styles.sevedPost}>
      <Box sx={styles.wrapper}>
        <Box sx={styles.container} className="hide-scrollbar">
          {isLoading || isFetching ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "calc(100vh - 100px)",
              }}
            >
              <CustomLoader />
            </Box>
          ) : localPosts && localPosts.length > 0 ? (
            localPosts.map((post) => (
              <Post key={post.uid} post={{ ...post }} onDelete={handleDeletePost} />
            ))
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "calc(100vh - 100px)",
              }}
            >
              <Typography sx={{ textAlign: "center" }}>No saved posts</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SavedPost;
